import { render } from "./AlGoals.vue?vue&type=template&id=922c98ea&scoped=true"
import script from "./AlGoals.vue?vue&type=script&lang=js"
export * from "./AlGoals.vue?vue&type=script&lang=js"

import "./AlGoals.vue?vue&type=style&index=0&id=922c98ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922c98ea"]])

export default __exports__